export default "__VITE_ASSET__eaab7adc__"